const ITEMS = [
  "Palm Beach",
  "Miami",
  "Fort Lauderdale",
  "Private Jet & FBO Transfers",
  "Weddings",
  "Corporate Roadshows",
  "Worth Avenue",
  "24/7 On-Demand",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-[#E5DEC9] bg-[#FAF7F2] py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif-lux italic text-xl sm:text-2xl text-[#111318]/60 px-8">{item}</span>
                <span className="text-[#C5A059] text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
